const characters = [
    {
        "id": 1,
        "name": "Pepper Mint",
        "characterColor": "peppermint",
        "movePriority": 1,
        "imageResource": "https://terror-prom-media.s3.amazonaws.com/character-resources/peppermint.webp"
    },
    {
        "id": 2,
        "name": "Janitor Mustard",
        "characterColor": "mustard",
        "movePriority": 2,
        "imageResource": "https://terror-prom-media.s3.amazonaws.com/character-resources/mustard.webp"
    },
    {
        "id": 3,
        "name": "Lunchlady White",
        "characterColor": "white",
        "movePriority": 3,
        "imageResource": "https://terror-prom-media.s3.amazonaws.com/character-resources/white.webp"
    },
    {
        "id": 4,
        "name": "Sam Green",
        "characterColor": "green",
        "movePriority": 4,
        "imageResource": "https://terror-prom-media.s3.amazonaws.com/character-resources/green.webp"
    },
    {
        "id": 5,
        "name": "John Peakjock",
        "characterColor": "blue",
        "movePriority": 5,
        "imageResource": "https://terror-prom-media.s3.amazonaws.com/character-resources/peakjock.webp"
    },
    {
        "id": 6,
        "name": "Principal Plum",
        "characterColor": "purple",
        "movePriority": 6,
        "imageResource": "https://terror-prom-media.s3.amazonaws.com/character-resources/plum.webp"
    }
];

export default characters;
